import { render } from "./VabeneAddSupplement.vue?vue&type=template&id=29a9028e&ts=true"
import script from "./VabeneAddSupplement.vue?vue&type=script&lang=ts"
export * from "./VabeneAddSupplement.vue?vue&type=script&lang=ts"

import "./VabeneAddSupplement.vue?vue&type=style&index=0&id=29a9028e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__